import * as API from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { infoFunction } from "../../../../Components/Alert/Alert";

// ledger summary report
export const getSummaryLedgerReport = createAsyncThunk(
  "ledger/getSummaryLedgerReport",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo, account, group, cashAccount } = params;
      const { data } = await API.getSummaryLedgerReportData({
        rowsPerPage: rowsPerPage,
        search,
        sortOrder,
        pageNo,
        group,
        account,
        cashAccount,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get previous  page
export const getSummaryPrevious = createAsyncThunk(
  "ledger/getSummaryPrevious",
  async (previous, { rejectWithValue }) => {
    try {
      const { data } = await API.getSummaryPrevious(previous);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// get next  page
export const getSummaryNext = createAsyncThunk("ledger/getSummaryNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getSummaryNext(next);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

//get particular page
export const getSummaryParticularPage = createAsyncThunk(
  "ledger/getSummaryParticularPage",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, number, account, group, cashAccount } = params;
      const { data } = await API.getSummaryParticularPage({
        number,
        rowsPerPage,
        search,
        group,
        account,
        cashAccount,
      });
      if (!data?.data.length > 0) {
        infoFunction("Data Not found");
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// -------------------------------------------------------
// detail report
export const getDetailLedgerReport = createAsyncThunk(
  "ledger/getDetailLedgerReport",
  async (params, { rejectWithValue }) => {
    try {
 
      const { rowsPerPage, search, sortOrder, pageNo, account = "", group, cashAccount = false } = params;
      const { data } = await API.getDetailLedgerReportData({
        rowsPerPage: rowsPerPage,
        search,
        sortOrder,
        pageNo,
        group,
        account,
        cashAccount,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get previous  page
export const getDetailPrevious = createAsyncThunk("ledger/getDetailPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getDetailPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// get next  page
export const getDetailNext = createAsyncThunk("ledger/getDetailNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getDetailNext(next);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

//get particular page
export const getDetailParticularPage = createAsyncThunk(
  "ledger/getDetailParticularPage",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, number, account = "", group = "", cashAccount = false } = params;
      const { data } = await API.getDetailParticularPage({
        number,
        rowsPerPage,
        search,
        group: group ? group?.id : "",
        account: account ? account?.id : "",
        cashAccount,
      });
      if (!data?.data.length > 0) {
        infoFunction("Data Not found");
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
